import React from "react";
import logo_otp from "../../assets/svgicons/logo_otp.svg";

const FooterOTPIcon = () => {
	return <img src={logo_otp} width={120} alt="FooterLogoIcon" />;
};

export default FooterOTPIcon;
